// import React from 'react';

// const categories = [
//   { id: 1, name: 'Scooter', image: '/assets/scooter.png' },
//   { id: 2, name: 'Sports', image: '/assets/sports.png' },
//   { id: 3, name: 'Cruiser', image: '/assets/cruiser.png' },
//   { id: 4, name: 'Go-Electric', image: '/assets/electric.png' },
// ];

// const CategoryFilter = () => {
//   return (
//     <div className="min-h-screen flex flex-col justify-between bg-white">
//       <div>
//         {/* Header */}
//         <div className="bg-gradient-to-r from-orange-400 to-[#FF9630] p-4 flex items-center">
//           <button className="text-white">
//             <span className="text-2xl font-semibold">&larr;</span>
//           </button>
//           <h2 className="ml-4 text-white text-lg font-semibold">Categories</h2>
//         </div>

//         {/* Categories Grid */}
//         <div className="grid grid-cols-2 gap-6 p-6">
//           {categories.map((category) => (
//             <div
//               key={category.id}
//               className="flex flex-col items-center justify-center border rounded-md p-4 shadow-md cursor-pointer hover:shadow-lg transition"
//             >
//               <img src={category.image} alt={category.name} className="w-16 h-16 mb-2" />
//               <span className="text-sm font-medium text-gray-800">{category.name}</span>
//             </div>
//           ))}
//         </div>
//       </div>

//       {/* Buttons */}
//       <div className="flex justify-between p-4 bg-white">
//         <button className="border-2 border-[#FF9630] text-[#FF9630] font-medium py-2 px-6 rounded-md hover:bg-orange-100">
//           CLEAR
//         </button>
//         <button className="bg-[#FF9630] text-white font-medium py-2 px-6 rounded-md hover:bg-orange-600">
//           ADD TO FILTER
//         </button>
//       </div>
//     </div>
//   );
// };

// export default CategoryFilter;

// import React from "react";
// import sportsImage1 from "../../assets/C1.png";
// import sportsImage2 from "../../assets/C2.png";
// import sportsImage3 from "../../assets/C3.png";
// import sportsImage4 from "../../assets/C4.png";

// const categories = [
//   { id: 1, name: "Scooter", image: sportsImage1 },
//   { id: 2, name: "Sports", image: sportsImage2 },
//   { id: 2, name: "Cruiser", image: sportsImage3 },
//   { id: 2, name: "Electrical", image: sportsImage4 },
// ];

// const Categories = ({ closeModal }) => {
//   return (
//     <div className="min-h-screen flex flex-col justify-between  bg-white">
//       <div>
//         {/* Header */}
//         <div className="bg-gradient-to-r from-orange-400 to-[#FF9630] p-4 flex items-center">
//           <button onClick={closeModal} className="text-white">
//             <span className="text-2xl font-semibold">&larr;</span>
//           </button>
//           <h2 className="ml-4 text-white text-lg font-semibold">Categories</h2>
//         </div>

//         {/* Categories Grid */}
//         <div className="grid grid-cols-2 gap-6 p-6">
//           {categories.map((category) => (
//             <div
//               key={category.id}
//               className="flex flex-col items-center justify-center border rounded-md p-4 shadow-md cursor-pointer hover:shadow-lg transition"
//             >
//               <img
//                 src={category.image}
//                 alt={category.name}
//                 className="w-16 h-16 mb-2"
//               />
//               <span className="text-sm font-medium text-gray-800">
//                 {category.name}
//               </span>
//             </div>
//           ))}
//         </div>
//       </div>

//       {/* Buttons */}
//       <div className="flex justify-between p-4 bg-white">
//         <button
//           onClick={closeModal}
//           className="border-2 border-[#FF9630] text-[#FF9630] font-medium py-2 px-6 rounded-md hover:bg-orange-100"
//         >
//           CLEAR
//         </button>
//         <button className="bg-[#FF9630] text-white font-medium py-2 px-6 rounded-md hover:bg-orange-600">
//           ADD TO FILTER
//         </button>
//       </div>
//     </div>
//   );
// };

// export default Categories;


import React, { useState } from "react";
import sportsImage1 from "../../assets/C1.png";
import sportsImage2 from "../../assets/C2.png";
import sportsImage3 from "../../assets/C3.png";
import sportsImage4 from "../../assets/C4.png";

const categories = [
  { id: 1, name: "Scooter", image: sportsImage1 },
  { id: 2, name: "Sports", image: sportsImage2 },
  { id: 3, name: "Cruiser", image: sportsImage3 },
  { id: 4, name: "Electrical", image: sportsImage4 },
];

const Categories = ({ closeModal }) => {
  const [selectedCategory, setSelectedCategory] = useState(null);

  const handleCategoryClick = (id) => {
    setSelectedCategory(id);
  };

  return (
    
    <div className="h-screen flex flex-col justify-between bg-white">
      <div>
        {/* Header */}
        <div className="bg-gradient-to-r from-orange-400 to-[#FF9630] p-4 flex items-center">
          <button onClick={closeModal} className="text-white">
            <span className="text-2xl font-semibold">&larr;</span>
          </button>
          <h2 className="ml-4 text-white text-lg font-semibold">Categories</h2>
        </div>

        {/* Categories Grid */}
        <div className="grid grid-cols-2 gap-6 p-6">
          {categories.map((category) => (
            <div
              key={category.id}
              onClick={() => handleCategoryClick(category.id)}
              className={`flex flex-col items-center justify-center border rounded-md p-4 shadow-md cursor-pointer transition ${
                selectedCategory === category.id
                  ? "bg-orange-100 border-[#FF9630]"
                  : "hover:bg-orange-50"
              }`}
            >
              <img
                src={category.image}
                alt={category.name}
                className="w-16 h-16 mb-2"
              />
              <span className="text-sm font-medium text-gray-800">
                {category.name}
              </span>
            </div>
          ))}
        </div>
      </div>

      {/* Buttons */}
      <div className="flex justify-between p-4 bg-white">
        <button
          onClick={() => {
            setSelectedCategory(null);
            closeModal();
          }}
          className="border-2 border-[#FF9630] text-[#FF9630] font-medium py-2 px-6 rounded-md hover:bg-orange-100"
        >
          CLEAR
        </button>
        <button className="bg-[#FF9630] text-white font-medium py-2 px-6 rounded-md hover:bg-orange-600">
          ADD TO FILTER
        </button>
      </div>
    </div>
  );
};

export default Categories;
